import * as React from 'react';
import { IOption, IOptionGroup } from "../../classes/seating-option";
import Checkbox from './checkbox';

interface ICheckBoxGroupProps {
    key?: string;
    id?: string;
    stateChangeFunction: (selectedOptions: IOption[], groupId: string) => void;
    selectedOptions?: Array<IOption>;
    showAllOption: boolean;
    allText: string;
    group: IOptionGroup
}

interface ICheckBoxGroupState {
    selectedOptions: Array<IOption>;
    allCheckboxSelected: boolean;
}

class CheckBoxGroup extends React.PureComponent<ICheckBoxGroupProps, ICheckBoxGroupState> {

    constructor(props) {
        super(props);
        const selectedOptions = props.selectedOptions != null ? props.selectedOptions : [];

        this.state = {
            selectedOptions: selectedOptions,
            allCheckboxSelected: selectedOptions.length === 0 || props.group.options.length === props.selectedOptions.length
        }
    }

    componentWillReceiveProps(nextProps: ICheckBoxGroupProps) {
        if (this.props.selectedOptions.length !== nextProps.selectedOptions.length) {
            const selectedOptions = nextProps.selectedOptions != null ? nextProps.selectedOptions : [];

            this.setState({
                allCheckboxSelected: selectedOptions.length === 0 || nextProps.group.options.length === nextProps.selectedOptions.length
            })
        }
    }

    render() {
        return (
            <ul>
                {
                    this.props.showAllOption ?
                        <Checkbox key="all"
                            onChangeFunction={this._selectAllOption}
                            checked={this.state.allCheckboxSelected} option={{ id: "all", name: this.props.allText, selected: this.state.allCheckboxSelected }}
                            groupName={this.props.group.name} />
                        : null
                }
                {
                    this.props.group.options.filter(option => option.name != null && option.name.length > 0)
                        .map(option => {
                            // Mark if a selected option is in this option group.
                            let match = this.props.selectedOptions.some(selectedOption => selectedOption.id === option.id);

                            return <Checkbox key={option.id}
                                onChangeFunction={this._selectOption}
                                checked={match} option={option} groupName={this.props.group.name} />
                        }, this)
                }
            </ul>
        );
    }

    _selectAllOption = () => {
        //this.setState({
        //    ...this.state,
        //    allCheckboxSelected: !this.state.allCheckboxSelected
        //});

        let newSeatingOptions = this.props.group.options;
        this.props.stateChangeFunction(newSeatingOptions, this.props.group.id)
    };


    _selectOption = (option: IOption) => {
        option.selected = !option.selected;

        let currSeatingOptions = this.state.selectedOptions;
        let newSeatingOptions: IOption[];

        /*
        Check to see if seating options already have the selected option. If it does, remove it. Need this array
        because when the option is checked, it should be added to the array of seating options. If it's removed,
        it should be removed from the seating options.
        */
        const withoutSelectedOptions = this.state.selectedOptions.filter(selectedOption => selectedOption.id !== option.id);

        if (!currSeatingOptions.some(currOption => currOption.id === option.id)) {
            newSeatingOptions = withoutSelectedOptions.concat([option]);
        } else {
            newSeatingOptions = withoutSelectedOptions;
        }

        this.setState({
            selectedOptions: newSeatingOptions
        });

        this.props.stateChangeFunction(newSeatingOptions, this.props.group.id)
    };
}

export default CheckBoxGroup;